import { Checkbox, List, Switch } from "../../design";
import { type DialogProps, Dialog } from "../../design/Dialog";
import { NavigationRail } from "../../navigation";

// Konkord: the aliases call through at render time. Reading `List.Subheader`
// while this module loads gave `undefined` in the build (module order), so the
// friends list threw "t is not a function" and stayed on the spinner.

/**
 * @deprecated Use the `Dialog` export instead!
 */
export const Modal2 = Dialog;

/**
 * @deprecated Use the `DialogScrim` export instead!
 */
export const ModalScrim: typeof Dialog.Scrim = (props) => Dialog.Scrim(props);

/**
 * @deprecated Use the `DialogProps` export instead!
 */
export type Modal2Props = DialogProps;

/**
 * @deprecated Use the `List.Item` export instead!
 */
export const ListItem: typeof List.Item = (props) => List.Item(props);

/**
 * @deprecated Use the `List.Subheader` export instead!
 */
export const ListSubheader: typeof List.Subheader = (props) => List.Subheader(props);

/**
 * @deprecated Use the `NavigationRail.Item` export instead!
 */
export const NavigationRailItem: typeof NavigationRail.Item = (props) => NavigationRail.Item(props);

/**
 * @deprecated Use the `Switch.Override` export instead!
 */
export const OverrideSwitch: typeof Switch.Override = (props) => Switch.Override(props);

/**
 * @deprecated Use the `Checkbox` export instead!
 */
export const Checkbox2 = Checkbox;

export * from "./ComboBox";
export * from "./Form";
export * from "./Input";
export * from "./InputElement";
export * from "./LegacyCheckbox";
export * from "./Radio";
export * from "./SegmentedButton";
export * from "./Username";
